import { render, staticRenderFns } from "./f-navigation.vue?vue&type=template&id=3ab8a608&"
import script from "./f-navigation.vue?vue&type=script&lang=js&"
export * from "./f-navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports